export default __webpack_public_path__ + "static/raw-preview-1-e05c2e51f9eb0bcd4a22b9381dd5695b.jpg";